var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "envelope-solid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M58 8C61.3125 8 64 10.6862 64 14C64 15.8875 63.1125 17.6625 61.6 18.8L34.4 39.2C32.975 40.2625 31.025 40.2625 29.6 39.2L2.4 18.8C0.889125 17.6625 0 15.8875 0 14C0 10.6862 2.68625 8 6 8H58ZM27.2 42.4C30.05 44.5375 33.95 44.5375 36.8 42.4L64 22V48C64 52.4125 60.4125 56 56 56H8C3.58125 56 0 52.4125 0 48V22L27.2 42.4Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.6548d6194b01d0d2068f77994a964e5b.svg";
export { ForwardRef as ReactComponent };